class ErrorExt extends Error {
  constructor(message, opts) {
    super(message);
    Object.assign(this, opts);
  }
}

export default ErrorExt;



// WEBPACK FOOTER //
// ./src/others/error-ext.js